import React from 'react';

/**
 * NairaSign (₦) Icon conforming to Lucide icon specification (24x24 viewBox, stroke-based)
 */
export const NairaSign = ({ className = "w-4 h-4", strokeWidth = 2.2, ...props }) => (
  <svg 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth={strokeWidth} 
    strokeLinecap="round" 
    strokeLinejoin="round" 
    className={`inline-block shrink-0 ${className}`}
    aria-hidden="true"
    {...props}
  >
    {/* Capital letter N */}
    <path d="M6 19V5l12 14V5" />
    {/* Upper and lower horizontal crossbars */}
    <line x1="3.5" y1="9.5" x2="20.5" y2="9.5" />
    <line x1="3.5" y1="14.5" x2="20.5" y2="14.5" />
  </svg>
);

export default NairaSign;
